var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24178 13.779C6.9381 13.779 6.66602 14.0349 6.66602 15.2605V17.4828C6.66602 18.7085 6.9381 18.9642 8.24178 18.9642H11.3933V27.8532C11.3933 29.0788 11.6654 29.3346 12.969 29.3346H16.1205C17.4243 29.3346 17.6963 29.0788 17.6963 27.8532V18.9642H21.2349C22.2237 18.9642 22.4785 18.7836 22.7501 17.8898L23.4255 15.6676C23.8907 14.1365 23.604 13.779 21.9103 13.779H17.6963V10.0754C17.6963 9.25718 18.4017 8.59389 19.272 8.59389H23.7569C25.0605 8.59389 25.3327 8.33809 25.3327 7.11241V4.14945C25.3327 2.92377 25.0605 2.66797 23.7569 2.66797H19.272C14.9207 2.66797 11.3933 5.98438 11.3933 10.0754V13.779H8.24178Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.da125e63f211da83a2e278f929db2b83.svg";
export { ForwardRef as ReactComponent };